module.exports = __webpack_public_path__ + "static/media/Illustration1.780f4ead.png";